// 수행평가
import Resource from '../Resource'

export default class PortfolioTestAnswer extends Resource {
  static ENDPOINT = '/api/test/portfolio/answer'

  constructor (args) {
    super()
    this.extend(args)
  }

  makeGrade (test) {
    this.grade = []
    test.evals.forEach(e => {
      const scores = []
      e.items.forEach(i => {
        scores.push('상')
      })
      this.grade.push(scores)
    })
  }

  static create (test, student) {
    const portfolio = {
      training: test.training,
      student,
      subject: test.subject,
      name: test.name,
      code: test.code,
      grade: [],
      score: 0,
      comment: ''
    }

    test.evals.forEach(e => {
      const scores = []
      e.items.forEach(i => {
        scores.push('상')
      })
      portfolio.grade.push(scores)
    })
    // grade 배열 초기화 - 상값으로
    return new PortfolioTestAnswer(portfolio)
  }

  mark () {
    const count = this.grade.reduce((acc, c) => { // c 유사 배열 객체
      acc += Object.keys(c).length
      return acc
    }, 0)
    const unitScore = (100 / count)
    const level = {
      상: unitScore,
      중: (unitScore * 0.7),
      하: (unitScore * 0.3)
    }
    this.score = 0
    this.grade.forEach(e => {
      Object.keys(e).forEach(s => {
        this.score += level[e[s]] // 유사 배열의 값 접근
      })
    })
    this.score = Math.round(this.score)
  }
}
